import { Moon, Sun } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";
import { useLanguage } from "../contexts/LanguageContext";

/**
 * Toggle segmentato del tema, allineato visivamente a LanguageToggle e
 * FontSizeToggle: stesso contenitore, stessa altezza (h-6) dei bottoni.
 */
export function ThemeToggle() {
	const { theme, setTheme } = useTheme();
	const { t } = useLanguage();

	const baseBtn =
		"h-6 min-w-[30px] flex items-center justify-center leading-none";

	return (
		<div className="inline-flex items-center bg-secondary border border-border rounded-sm overflow-hidden">
			<button
				type="button"
				onClick={() => setTheme("dark")}
				title={t("themeDark")}
				aria-label={t("themeDark")}
				aria-pressed={theme === "dark"}
				className={`${baseBtn} ${
					theme === "dark"
						? "bg-volt text-white"
						: "text-muted-foreground hover:text-foreground"
				}`}
			>
				<Moon className="h-3.5 w-3.5" />
			</button>
			<div className="w-px self-stretch bg-border" />
			<button
				type="button"
				onClick={() => setTheme("light")}
				title={t("themeLight")}
				aria-label={t("themeLight")}
				aria-pressed={theme === "light"}
				className={`${baseBtn} ${
					theme === "light"
						? "bg-volt text-white"
						: "text-muted-foreground hover:text-foreground"
				}`}
			>
				<Sun className="h-3.5 w-3.5" />
			</button>
		</div>
	);
}
